
define('ldsh!modules/office_data/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>OfficeData</h1>\n<a class="btn btn-default" href="#/office_data/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="OfficeData-body">\n\t</tbody>\n</table>';

}
return __p
};});

